/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable */
import {
  makeStyles,
  RACCard,
  RACTabs,
  Typography,
  RACCOLOR,
  RACDateTimeLabel,
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next'; // Import i18next
import React, { useState, useMemo } from 'react';
import { ContactInformationCustomerContent } from './ContactInformationCustomerContent';
import { ContactInformationReferencesContent } from './ContactInformationReferencesContent';
import { ContactInformationEmployerContent } from './ContactInformationEmployerContent';
import { ContactInformationCoCustomerContent } from './ContactInformationCoCustomerContent';
import { LogActivityModal } from './LogActivityModal';
import { useWorkedHistoryActions } from '../../../context/WorkedHistory/WorkedHistoryProvider';
import {
  ACCT_ACTIVITY_REF_CODES,
  LOG_ACTIVITY_ERROR_MESSAGE,
} from '../../../constants/constants';
import { ApiErrorModal } from '../../../common/ApiError/ApiError';
import { useCustomerPaymentSummary } from '../../../context/CustomerPaymentSummary/CustomerPaymentSummaryProvider';
import {
  useCustomerDetails,
  useCustomerDetailsActions,
} from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { formatDateString } from '../../../utils/utils';
import { ContactInformationRecordCheckContent } from './ContactInformationRecordCheckContent';
import { useStoreDetails } from '../../../context/Store/StoreProvider';
import { FieldVisitModal } from '../CustomerInformation/FieldVisitModal';

/*
Reason for having both whiteSpace: 'nowrap' and <Typography noWrap ....>:
The one from css (th and td see below) will make the string to not break into new line.
The one from Typography will add the 3 dots (...) when string cannot be completely displayed.
*/
const useStyles = makeStyles((theme: any) => ({
  contactInformationRoot: {
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  row: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.typography.pxToRem(8),
  },
  // TODO Align with designers regarding the card height
  // Should have a fixed height? Should be the same height as for text messages?
  // Or height depends on the number of rows?
  cardContentContainer: {
    marginLeft: '1.25rem',
    marginRight: '1.25rem',
    overflowX: 'auto',
    '& th': {
      whiteSpace: 'nowrap',
    },
    '& td': {
      maxWidth: theme.typography.pxToRem(160),
      whiteSpace: 'break-spaces',
    },
  },
  tabPanel: {
    height: '26rem',
    maxHeight: '26rem',
    overflow: 'auto',
  },
  dueContainer: {
    display: 'flex',
    gap: theme.typography.pxToRem(8),
  },
  dueInfo: {
    paddingRight: theme.typography.pxToRem(8),
  },
  dueKey: {
    // color: `${RACCOLOR.MAXIMUM_RED} !important`,
  },
  dueValue: {
    color: `${RACCOLOR.CARNELIAN} !important`,
  },
  dueDate: {
    color: `${RACCOLOR.CARNELIAN} !important`,
    marginTop:'0px',
    paddingTop:'0px',
    fontFamily: 'OpenSans-semibold',
  },
}));

export const ContactInformation = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { isMXAccountManagement, DateTimeLocalization, store } = useStoreDetails();

  const [openLogActivityModal, setOpenLogActivityModal] = useState(false);
  // can be the customer, co-customer, employer or reference
  const [personId, setPersonId] = useState('');
  const [callType, setCallType] = useState('');
  const [phoneNo, setPhoneNo] = useState('');

  const [isApiErrorOpen, setIsApiErrorOpen] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');
  const [openFieldVisitModal, setOpenFieldVisitModal] = useState(false);
  const { onLogWorkedHistory, setReloadWorkedHistory } =
    useWorkedHistoryActions();
  const [subtype, setSubtype] = useState('');
  const [emailid, setEmailId] = useState(0);
  const [addressId, setAddressId] = useState(0);

  const {
    customerDetails: { coCustomerId, personalReferences, employerReferences },
    getCustomerdetail,
    coCustomerDetails,
    isRecordCheckData,
    setRecordCheckDataUnmask,
  } = useCustomerDetails();

  const { customerPaymentSummary: customerPaymentSummaryResponse } =
    useCustomerPaymentSummary();

  const { fetchCommunicationDetailsForCustomer } = useCustomerDetailsActions();
  const { isCustomerRecordCheckEnabled, customerSkipTraceRequestLevels } =
    useStoreDetails();

  let customerSource = '';
  const salesLeadId: any =
    getCustomerdetail && getCustomerdetail?.GetCustomer?.value?.salesLeadId;
  const verifyCode: any =
    getCustomerdetail &&
    getCustomerdetail?.GetApproval?.value?.customerApprovalDetails?.verifyCode;
  const isCreatedByECOM: any =
    (getCustomerdetail &&
      getCustomerdetail?.GetCustomer?.value?.createdBy == 'EC') ||
    (getCustomerdetail &&
      getCustomerdetail?.GetCustomer?.value?.createdBy == 'ECOM');

  console.log('salesLeadId Source', salesLeadId);
  console.log('verifyCode Source', verifyCode);
  console.log('isCreatedByECOM Source', isCreatedByECOM);
  //To identify the customer source
  if (verifyCode === '-1' || verifyCode === null) {
    customerSource = salesLeadId || isCreatedByECOM ? 'PW' : 'PC';
  } else if (verifyCode === '0' || verifyCode === '1') {
    customerSource = salesLeadId || isCreatedByECOM ? 'NW' : 'NC';
  }

  const AVAILABLE_TABS = useMemo(() => {
    return [
      'Customer',
      ...(!isMXAccountManagement ? ['Co-Customer'] : []),
      'References',
      'Employer',
      ...(isCustomerRecordCheckEnabled ? ['Customer Record Check'] : []),
    ];
  }, [isCustomerRecordCheckEnabled, isMXAccountManagement]);

  const disabledTabsToStore: number[] = [];

  const tabNameToIndex = (tabName: string) => AVAILABLE_TABS.indexOf(tabName);
  console.log('tabNameToIndex', tabNameToIndex);
  if (!coCustomerId && !coCustomerDetails.customerId) {
    const index = tabNameToIndex('Co-Customer');
    if (index !== -1) disabledTabsToStore.push(index);
  }
  if (!personalReferences?.length) {
    const index = tabNameToIndex('References');
    if (index !== -1) disabledTabsToStore.push(index);
  }
  if (!employerReferences?.length) {
    const index = tabNameToIndex('Employer');
    if (index !== -1) disabledTabsToStore.push(index);
  }
  if (
    !isCustomerRecordCheckEnabled ||
    (!isRecordCheckData && !(customerSource in customerSkipTraceRequestLevels))
  ) {
    const index = tabNameToIndex('Customer Record Check');
    if (index !== -1) disabledTabsToStore.push(index);
  }

  const onLogWorkedHistoryWithSuccess = () => {
    setOpenLogActivityModal(false);
    setApiErrorMessage('');
  };

  const onLogWorkedHistoryWithError = () => {
    setOpenLogActivityModal(false);
    setIsApiErrorOpen(true);
    setApiErrorMessage(i18n.t(LOG_ACTIVITY_ERROR_MESSAGE));
  };

  const daysPastDue = customerPaymentSummaryResponse?.pastDueSummary
    ?.daysPastDue
    ? customerPaymentSummaryResponse?.pastDueSummary?.daysPastDue
    : '';

  const handleError = (message: string) => {
    setApiErrorMessage(message);
    setIsApiErrorOpen(true);
  };
  const translatedTabs = AVAILABLE_TABS.map((tabKey) => t(`${tabKey}`));

  const handleFieldVisitSaveSuccess = () => {
    setOpenFieldVisitModal(false);
    setReloadWorkedHistory(true);
    setSubtype('');
    setAddressId(0);
  };

  const handleFieldVisitSaveError = () => {
    setOpenFieldVisitModal(false);
    setApiErrorMessage(LOG_ACTIVITY_ERROR_MESSAGE);
    setIsApiErrorOpen(true);
    setSubtype('');
    setAddressId(0);
  };

  const onTabChange = () => {
    setRecordCheckDataUnmask(false);
  };

  const contentTab = [
    <ContactInformationCustomerContent
      key="customer"
      onLogClicked={(personId: string, phone: string) => {
        setPersonId(personId);
        setCallType(ACCT_ACTIVITY_REF_CODES.CALL_CUSTOMER);
        setOpenLogActivityModal(true);
        setPhoneNo(phone);
      }}
      onError={handleError}
    />,
  ];

  if (!isMXAccountManagement) {
    contentTab.push(
      <ContactInformationCoCustomerContent
        key="co-customer"
        onLogClicked={(personId: string, phone: string) => {
          setPersonId(personId);
          setCallType(ACCT_ACTIVITY_REF_CODES.CALL_ALTERNATIVE);
          setOpenLogActivityModal(true);
          setPhoneNo(phone);
        }}
        onError={handleError}
      />
    );
  }

  contentTab.push(
    <ContactInformationReferencesContent
      key="references"
      onLogClicked={(personId: string, phone: string) => {
        setPersonId(personId);
        setCallType(ACCT_ACTIVITY_REF_CODES.CALL_REFERENCE);
        setOpenLogActivityModal(true);
        setPhoneNo(phone);
      }}
    />,
    <ContactInformationEmployerContent
      key="employer"
      onLogClicked={(personId: string, phone: string) => {
        setPersonId(personId);
        setCallType(ACCT_ACTIVITY_REF_CODES.CALL_EMPLOYER);
        setOpenLogActivityModal(true);
        setPhoneNo(phone);
      }}
    />,
    <ContactInformationRecordCheckContent
      key="Customer Records Check"
      // eslint-disable-next-line sonarjs/no-identical-functions
      onLogClicked={(personId: string, phone: string, subtype: string) => {
        setPersonId(personId);
        setCallType(ACCT_ACTIVITY_REF_CODES.CALL_CUSTOMER);
        setOpenLogActivityModal(true);
        setPhoneNo(phone);
        setSubtype(subtype);
      }}
      onFieldVisitClicked={(id: number, subtype: string) => {
        setSubtype(subtype);
        setAddressId(id);
        setOpenFieldVisitModal(true);
      }}
      onEmailLogClicked={(personId: string, id: number, subtype: string) => {
        setPersonId(personId);
        setCallType(ACCT_ACTIVITY_REF_CODES.CALL_CUSTOMER);
        setOpenLogActivityModal(true);
        setEmailId(id);
        setSubtype(subtype);
      }}
    />
  );
  return (
    <div className={classes.contactInformationRoot}>
      {isApiErrorOpen && (
        <ApiErrorModal
          open={isApiErrorOpen}
          message={apiErrorMessage}
          onClose={() => {
            setApiErrorMessage('');
            setIsApiErrorOpen(false);
          }}
        />
      )}
      <div className={classes.row}>
        <Typography noWrap variant="h4">
          {t('Contact Information')}
        </Typography>
        <div className={classes.dueContainer}>
          <div className={classes.dueInfo}>
            <Typography
              display="inline"
              variant="body1"
              className={classes.dueKey}
            >
              {t('Due Date:')}{' '}
            </Typography>
           { DateTimeLocalization ? 
           <RACDateTimeLabel 
           value={formatDateString(
                customerPaymentSummaryResponse?.pastDueSummary?.pastDueDate
              )} 
           country= {store?.countryAbb} 
           displayType ={'ShortDate'}
           className={classes.dueDate}
              />
           :
            <Typography
              display="inline"
              variant="h6"
              className={classes.dueValue}
            >
              {formatDateString(
                customerPaymentSummaryResponse?.pastDueSummary?.pastDueDate
              )}
            </Typography>
            }
          </div>
          <div className={classes.dueInfo}>
            <Typography
              display="inline"
              variant="body1"
              className={classes.dueKey}
            >
              {t('Days Past Due')}:{' '}
            </Typography>
            <Typography
              display="inline"
              variant="h6"
              className={classes.dueValue}
            >
              {daysPastDue}
            </Typography>
          </div>
          <div className={classes.dueInfo}>
            <Typography
              display="inline"
              variant="body1"
              className={classes.dueKey}
            >
              {t('Amount Due')}:{' '}
            </Typography>
            <Typography
              display="inline"
              variant="h5"
              className={classes.dueValue}
            >
              ${customerPaymentSummaryResponse?.pastDueSummary?.amountDue || ''}
            </Typography>
          </div>
        </div>
      </div>
      <RACCard>
        <div className={classes.cardContentContainer}>
          {openLogActivityModal && (
            <LogActivityModal
              open={openLogActivityModal}
              onSave={(callResult: string, note: string) => {
                onLogWorkedHistory(
                  callResult,
                  note,
                  daysPastDue?.toString(),
                  personId,
                  callType,
                  phoneNo,
                  onLogWorkedHistoryWithSuccess,
                  onLogWorkedHistoryWithError,
                  emailid,
                  subtype
                ).then(() => {
                  const isCoCustomer =
                    callType === ACCT_ACTIVITY_REF_CODES.CALL_ALTERNATIVE;

                  // logging co-customer call -> refresh co-customer call results
                  // otherwise -> refresh customer, reference, and employer call results
                  fetchCommunicationDetailsForCustomer(
                    undefined,
                    !isCoCustomer
                  );
                  setEmailId(0);
                  setSubtype('');
                  setPhoneNo('');
                });
              }}
              onClose={() => setOpenLogActivityModal(false)}
            />
          )}
          {openFieldVisitModal && (
            <FieldVisitModal
              onClose={setOpenFieldVisitModal}
              onSaveSuccess={handleFieldVisitSaveSuccess}
              onError={handleFieldVisitSaveError}
              subtype={subtype}
              addressId={addressId}
            />
          )}
          <RACTabs
            classes={{
              tabPanel: classes.tabPanel,
            }}
            defaultValue={0}
            tabs={translatedTabs}
            contentForTabs={contentTab}
            disabledTabs={disabledTabsToStore}
            onChange={onTabChange}
          />
        </div>
      </RACCard>
    </div>
  );
};
